export const breaks = [
  {
    startTime: '07:30',
    groupedTalks: [{ startTime: '07:30', isBreak: true, title: 'Registrations and Breakfast' }]
  },
  {
    startTime: '10:10',
    groupedTalks: [{ startTime: '10:10', isBreak: true, title: 'Coffee Break, Exhibition Area' }]
  },
  {
    startTime: '11:20',
    groupedTalks: [{ startTime: '11:20', isBreak: true, title: 'Break' }]
  },
  {
    startTime: '12:10',
    groupedTalks: [{ startTime: '12:10', isBreak: true, title: 'Lunch Break' }]
  },
  {
    startTime: '13:50',
    groupedTalks: [{ startTime: '13:50', isBreak: true, title: 'Break' }]
  },
  {
    startTime: '14:40',
    groupedTalks: [
      { startTime: '14:40', isBreak: true, title: 'Expert Discussions, Exhibition Area' }
    ]
  },
  {
    startTime: '15:50',
    groupedTalks: [{ startTime: '14:50', isBreak: true, title: 'Break' }]
  },
  {
    startTime: '16:40',
    groupedTalks: [{ startTime: '16:40', isBreak: true, title: 'Break' }]
  },
  {
    startTime: '17:30',
    groupedTalks: [{ startTime: '17:30', isBreak: true, title: 'Conference Closing' }]
  }
];

export const placeholders = [
  {
    startTime: '10:40',
    groupedTalks: [
      // { startTime: '10:40', trackInDay: 0, title: 'Coming Soon', tileRole: 'CLOSED', id: '10' },
    ]
  },
  {
    startTime: '14:00',
    groupedTalks: [
      {
        startTime: '14:00',
        trackInDay: 5,
        title: 'Technology and Sustainability Discussion',
        tileRole: 'CLOSED',
        id: '6'
      }
    ]
  },
  {
    startTime: '16:50',
    groupedTalks: [
      { startTime: '16:50', trackInDay: 1, title: 'Closed', tileRole: 'CLOSED', id: '4' },
      { startTime: '16:50', trackInDay: 2, title: 'Closed', tileRole: 'CLOSED', id: '5' }
    ]
  }
];

export const conferenceOpening = {
  startTime: '09:00',
  title: 'Conference Opening',
  room: '',
  track: 'Talk',
  isConferenceOpening: true,
  youtube: 'https://m.youtube.com/watch?v=Tixa7oob4X4',
  speakers: [
    { id: '1', name: 'Tomas Volek', company: 'Accenture', country: 'Slovakia' }
    // {
    //   id: '2',
    //   name: 'prof. Dr. Ing. Miloš Oravec',
    //   company:
    //     'Faculty of Electrical Engineering and Information Technology of STU in Bratislava',
    //   country: 'Slovakia'
    // }
  ]
};

export default { breaks, placeholders, conferenceOpening };
